import React from 'react';
import { SimpleCard } from '@redturtle/volto-io-studio/components';

import './cardsTemplate.less';

const CardsTemplate = (props) => {
  const { items } = props;

  return (
    <div className="cards-template">
      <div className="container cards-template-wrapper grid">
        {items.map((item) => {
          return item && <SimpleCard item={item} key={item['@id']} />;
        })}
      </div>
    </div>
  );
};

export default CardsTemplate;
